import { Routes } from '@angular/router';
import { PostsContainerComponent } from './containers/posts-container/posts-container.component'; 

export const postsRoutes: Routes = [
    {
        path:       '',
        component:  PostsContainerComponent
    },
];
